import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { PRIVACY } from "@/lib/content";

export const PrivacyPolicy = () => {
  return (
    <section id="privacy" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-600">
            <ShieldCheck size={24} />
          </span>
          <h2 className="mt-5 font-heading text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
            Privacy Policy
          </h2>
          <p className="mt-2 text-sm font-medium text-gray-500">{PRIVACY.updated}</p>
          <p className="mt-5 text-lg leading-relaxed text-gray-600">{PRIVACY.intro}</p>
        </motion.div>

        <div className="mt-12 space-y-10">
          {PRIVACY.sections.map((s, i) => (
            <motion.div
              key={s.heading}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`privacy-section-${i}`}
            >
              <h3 className="font-heading text-xl font-bold text-gray-900">{s.heading}</h3>
              <p className="mt-2 leading-loose text-gray-600">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
